import React, { useEffect, useState } from 'react';
import './Customers.css';
import Select from 'react-select';
import { ClipLoader } from 'react-spinners';
import { secureFetch } from '../../utils/secureFetch';

export default function Customers({ providerId, onContinue, privado = false }) {
    const [userData, setUserData] = useState(null);
    const [form, setForm] = useState({
        nombre: '',
        celular: '',
        direccion: '',
        ciudad: '',
        departamento: '',
        referencia: '',
    });
    const [editMode, setEditMode] = useState(true);
    const [loading, setLoading] = useState(true);
    const [departments, setDepartments] = useState([]);
    const [ciudades, setCiudades] = useState([]);
    const [selectedDept, setSelectedDept] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);

    useEffect(() => {
        if (!privado) {
            const usuario = JSON.parse(localStorage.getItem('usuario'));
            if (!usuario) {
                console.error('Usuario no encontrado en localStorage');
                return;
            }
            setUserData(usuario);
        }
    }, [privado]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!privado) {
                    const usuario = JSON.parse(localStorage.getItem('usuario'));

                    const resCustomer = await secureFetch('https://api.minymol.com/customers/me');

                    if (resCustomer.ok) {
                        const customer = await resCustomer.json();
                        setForm({
                            nombre: customer.nombre || usuario?.nombre || '',
                            celular: customer.celular || usuario?.telefono || '',
                            direccion: customer.direccion || '',
                            ciudad: customer.ciudad || '',
                            departamento: customer.departamento || '',
                        });
                        setSelectedDept(customer.departamento);
                        setSelectedCity(customer.ciudad);
                        setEditMode(false);
                    } else {
                        setForm({
                            nombre: usuario?.nombre || '',
                            celular: usuario?.telefono || '',
                            direccion: '',
                            ciudad: usuario?.ciudad || '',
                            departamento: usuario?.departamento || '',
                        });
                        setEditMode(true);
                    }
                }
            } catch (e) {
                console.error('Error cargando datos del cliente', e);
                setEditMode(true);
            } finally {
                setLoading(false);
            }
        };

        const fetchDepts = async () => {
            try {
                const res = await fetch('https://raw.githubusercontent.com/marcovega/colombia-json/master/colombia.json');
                const data = await res.json();
                setDepartments(data);
            } catch (e) {
                console.error('Error cargando departamentos', e);
            }
        };

        fetchData();
        fetchDepts();
    }, [privado]);

    useEffect(() => {
        if (selectedDept) {
            const depto = departments.find(d => d.departamento === selectedDept);
            setCiudades(depto ? depto.ciudades.map(c => ({ value: c, label: c })) : []);
        }
    }, [selectedDept, departments]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleContinue = async () => {
        if (!form.nombre.trim() || !form.celular.trim()) {
            alert('Por favor completa tu nombre y número de celular.');
            return;
        }

        if (privado) {
            if (onContinue) {
                onContinue({
                    nombre: form.nombre,
                    celular: form.celular,
                    departamento: selectedDept,
                    ciudad: selectedCity,
                    direccion: form.direccion,
                });
            }
        } else {
            try {
                const body = {
                    ...form,
                    departamento: selectedDept,
                    ciudad: selectedCity,
                    providerId,
                    userId: userData?.id,
                };

                const res = await secureFetch('https://api.minymol.com/customers/from-user', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body),
                });

                const data = await res.json();

                if (onContinue) onContinue(data ?? null);
            } catch (e) {
                console.error('Error creando el cliente:', e);
                if (onContinue) onContinue(null);
            }
        }
    };

    if (loading && !privado) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '10vh'
            }}>
                <ClipLoader color="#fa7e17" size={50} />
            </div>
        );
    }
    
    return (
        <div className="customer-box">
            {editMode ? (
                <div className="form">
                    <h2>Tus datos</h2>

                    <label>Nombre</label>
                    <input name="nombre" value={form.nombre} onChange={handleChange} placeholder="Ej.: Juan Lopez" />

                    <label>Celular</label>
                    <input
                        name="celular"
                        value={form.celular}
                        onChange={handleChange}
                        placeholder="Ej.: 3101234567"
                        readOnly={!privado && !!userData?.telefono}
                        style={!privado && !!userData?.telefono ? { backgroundColor: '#eee', cursor: 'not-allowed' } : {}}
                    />

                    <label>Dirección</label>
                    <input name="direccion" value={form.direccion} onChange={handleChange} placeholder="Ej.: Calle 123 # 456" />

                    <label>Nombre del negocio o referencia</label>
                    <input name="referencia" value={form.referencia} onChange={handleChange} placeholder="Ej.: Zapatos Shop" />

                    <label>Departamento</label>
                    <Select
                        options={departments.map(d => ({ value: d.departamento, label: d.departamento }))}
                        value={selectedDept ? { value: selectedDept, label: selectedDept } : null}
                        onChange={(selected) => {
                            setSelectedDept(selected?.value || null);
                            setSelectedCity(null);
                        }}
                        placeholder="Selecciona un departamento"
                    />

                    <label>Ciudad</label>
                    <Select
                        options={ciudades}
                        value={selectedCity ? { value: selectedCity, label: selectedCity } : null}
                        onChange={(selected) => setSelectedCity(selected?.value || null)}
                        placeholder="Selecciona una ciudad"
                    />

                    <button className='customer-btn' onClick={handleContinue}>Continuar</button>
                </div>
            ) : (
                <div className="summary">
                    <p><strong>Nombre:</strong> {form.nombre}</p>
                    <p><strong>Celular:</strong> {form.celular}</p>
                    <p><strong>Dirección:</strong> {form.direccion}</p>
                    <p><strong>Ciudad:</strong> {form.ciudad}</p>
                    <p><strong>Departamento:</strong> {form.departamento}</p>
                    <div className="actions">
                        <button className='edit-btn-customer' onClick={() => setEditMode(true)}>Editar</button>
                        <button className='customer-btn' onClick={handleContinue}>Continuar</button>
                    </div>
                </div>
            )}
        </div>
    );
}
